import { Navigate, useLocation, type RouteObject } from "react-router-dom";

// Paths that moved when settings became tabbed pages (spec §6), plus the
// tracker app's old aliases. Query string and hash are kept.
const RULES: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
  [/^\/legionella-settings\/?$/, () => "/legionella/settings"],
  [/^\/legionella-settings\/([^/]+)\/?$/, (m) => `/legionella/settings/${m[1]}`],
  [/^\/legionella\/(asset-types|programmes|compliance-bands)\/?$/, (m) => `/legionella/settings/${m[1]}`],
  [/^\/vehicles\/(trackers|api-keys|audit)\/?$/, (m) => `/vehicles/settings/${m[1]}`],
  [/^\/hr\/(documents|background-checks|import)\/?$/, (m) => `/hr/settings/${m[1]}`],
  [/^\/fleet\/?$/, () => "/vehicles/live"],
  [/^\/drivers\/?$/, () => "/vehicles/drivers"],
];

export function legacyTarget(pathname: string): string | null {
  for (const [re, to] of RULES) {
    const m = pathname.match(re);
    if (m) return to(m);
  }
  return null;
}

function LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={(legacyTarget(pathname) ?? "/") + search + hash} replace />;
}

const LEGACY_PATHS = [
  "/legionella-settings", "/legionella-settings/:tab",
  "/legionella/asset-types", "/legionella/programmes", "/legionella/compliance-bands",
  "/vehicles/trackers", "/vehicles/api-keys", "/vehicles/audit",
  "/hr/documents", "/hr/background-checks", "/hr/import",
  "/fleet", "/drivers",
];

export const legacyRoutes: RouteObject[] = LEGACY_PATHS.map((path, i) => ({
  id: `legacy.${i}`,
  path,
  element: <LegacyRedirect />,
}));
